import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";

const LAP = () => {
  const { state } = useLocation();
  const lead = state?.lead;

  return (
    <Box p={3}>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        🏦 Loan Against Property Process Flow
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>Name: {lead?.name}</Typography>
        <Typography>Property Value: {lead?.monthly_income}</Typography>
        <Typography>Requested Amount: {lead?.req_loan_amt}</Typography>
        {/* Add LAP-specific steps here */}
      </Paper>
    </Box>
  );
};

export default LAP;